import { SVGProps } from 'react';
import { Gb, Jp, Pt, Ar, Tr, Es, Cn, Kr } from 'react-flags-select';

export const countries = ['ae', 'jp', 'tr', 'br'];

export const supportedLanguages = ['en', 'ja', 'pt', 'ar', 'tr', 'zh', 'hk', 'es', 'kr'];

interface Language {
    value: string;
    title: any;
    icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}

export const getIcon = (value: string) => {
    switch (value) {
        case 'en':
            return Gb;
        case 'ar':
            return Ar;
        case 'de':
            return Gb;
        case 'ja':
            return Jp;
        case 'pt':
            return Pt;
        case 'tr':
            return Tr;
        case 'zh':
            return Cn;
        case 'hk':
            return Cn;
        case 'es':
            return Es;
        case 'kr':
            return Kr;
        default:
            return Gb;
    }
};

export const useLanguage = () => {
    const getTitle = (value: string) => {
        switch (value) {
            // english
            case 'en':
                return 'English';
            // arabic
            case 'ar':
                return 'عربي';
            // german
            case 'de':
                return 'Deutsch';
            // japanese
            case 'ja':
                return '日本';
            // portuguese
            case 'pt':
                return 'Português';
            // turkish
            case 'tr':
                return 'Türkçe';
            // chinese
            case 'zh':
                return '中文';
            // traditional chinese
            case 'hk':
                return '繁體中文';
            // spanish
            case 'es':
                return 'Español';
            // korean
            case 'kr':
                return '한국어';
            default:
                return null;
        }
    };

    const languages: Language[] = supportedLanguages.map((o) => ({
        value: o,
        title: getTitle(o),
        icon: getIcon(o),
    }));

    return {
        languages,
    };
};
